import InfiniteScroll from "react-infinite-scroller";
import React, { createElement, useState } from "react";
import { useNotify } from "../../hooks/useNotify.js";
import { useResource } from "../../hooks/useResource.js";

export function PaginationTable({
  pagination,
  resourceName,
  headers,
  onRowClick,
  component,
  bulkActions,

  noDataState,
  noResultState,
}) {
  let [selectedIds, setSelectedIds] = useState([]);

  let notify = useNotify();
  let resource = useResource(resourceName);

  let [isLoading, setIsLoading] = useState(false);

  let loadPage = (page) => {
    setIsLoading(true);
    resource
      .list({
        page,
        ...pagination.getMeta(),
      })
      .then(async (res) => {
        return pagination.append(res);
      })
      .catch(async (e) => {
        // Cannot load, for instance, due to invalid filters
        pagination.setFailed(true);
        notify({ message: "Cannot load data", type: "danger" });
      })
      .finally(() => setIsLoading(false));
  };

  let cellStyle = "py-3 px-5 text-left";

  if (!pagination.hasMore() && pagination.getData().length == 0) {
    if (
      pagination.getMeta().search == "" &&
      pagination.getMeta().filters == ""
    ) {
      return <>{noDataState}</>;
    } else {
      return <>{noResultState}</>;
    }
  }

  return (
    <div
      key={pagination.resetToken()}
      className={"flex flex-column overflow-hidden flex-grow flex-col"}
    >
      <div className={"overflow-auto flex-grow"}>
        <InfiniteScroll
          pageStart={0}
          loadMore={loadPage}
          hasMore={
            isLoading || pagination.getFailed() ? false : pagination.hasMore()
          }
          loader={
            <div className="loader" key={0}>
              Loading ...
            </div>
          }
          useWindow={false}
        >
          <div className={"border border-blue-50 rounded w-full overflow-auto"}>
            <table className={"w-full"}>
              <tbody>
                {pagination.getData().map((line, i) => {
                  return (
                    <tr key={line.id} onClick={() => onRowClick(line)}>
                      <td>
                        {component({
                          line,
                        })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
}
